
import Vue from "vue";
import { showComponentMixin } from "@/utils/mixins";
import { FTextareaField, FTextField, FPersonnummerTextField, FOrganisationsnummerTextField } from "@fkui/vue";
import { mapFields } from "vuex-map-fields";
import { VilkenRoll } from "@/store/types";
import AnonymFieldGroup from "@/components/Kontaktuppgifter/AnonymFieldGroup.vue";
import PersonnummerFieldGroup from "@/components/Kontaktuppgifter/PersonnummerFieldGroup.vue";

export default Vue.extend({
    name: "FkKontaktuppgifter",
    components: {
        FTextareaField,
        FTextField,
        FPersonnummerTextField,
        FOrganisationsnummerTextField,
        AnonymFieldGroup,
        PersonnummerFieldGroup,
    },
    mixins: [showComponentMixin],
    data: () => ({
        VilkenRoll,
    }),
    computed: {
        textContext(): string {
            const vilkenRoll = this.$store.state.forsteg.vilkenroll;
            if (vilkenRoll === VilkenRoll.PRIVATPERSON) {
                return "privat";
            }
            return "myndighet";
        },
        ...mapFields([
            "kontaktuppgifter.anmalareVarJobbar",
            "kontaktuppgifter.anmalareDittFornamn",
            "kontaktuppgifter.anmalareDittEfternamn",
            "kontaktuppgifter.anmalareDinTelefon",
            "kontaktuppgifter.anmalareOvrigKontaktuppgift",
            "kontaktuppgifter.anmaldFornamn",
            "kontaktuppgifter.anmaldEfternamn",
            "kontaktuppgifter.anmaldPersonnummer",
            "kontaktuppgifter.anmaldKontaktuppgift",
            "kontaktuppgifter.foretagForetradare",
            "kontaktuppgifter.foretagNamn",
            "kontaktuppgifter.foretagOvrigaUppgifter",
            "kontaktuppgifter.organisationsnummer",
            "forsteg.vilkenroll",
        ]),
    },
});
